// @flow

import _ from 'lodash/fp';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import AdminList from '../../components/AdminList/AdminList';
import SelectFormInput from '../../components/SelectFormInput/SelectFormInput';
import LoadingIndicator from '../../components/LoadingIndicator/LoadingIndicator';
import SearchField from '../../components/SearchField/SearchField';
import {
  fetchWorkerTypes,
  filterWorkerTypes,
  sortItems,
} from '../../actions/workerTypeList';
import booleanValues from '../../booleanValues';

const columns = [{
  property: 'name',
  header: {
    label: 'Namn',
  },
}];

export type Props = {
  history: Object,
  fetchWorkerTypes: Function,
  filterWorkerTypes: Function,
  location: { pathname: string },
  filter: {
    archived: boolean,
    query?: string,
  },
  workerTypes: any[],
  isFetching: boolean,
  sortItems: typeof sortItems,
};

class WorkerTypesContainer extends Component<Props> {
  props: Props;

  componentWillMount() {
    this.props.fetchWorkerTypes();
  }

  render() {
    const {
      history,
      filter,
      workerTypes,
      filterWorkerTypes,
      location: {pathname},
      isFetching,
      sortItems,
    } = this.props;

    return (
      <div className="WorkerTypesContainer relative">
        <LoadingIndicator isLoading={isFetching} />
        <div className="row align-middle">
          <div className="column">
            <SearchField
              value={filter.query || ''}
              onClear={e => filterWorkerTypes('', filter.archived)}
              onChange={e => filterWorkerTypes(e.target.value, filter.archived)} />
          </div>
          <div className="column shrink">
            <button
              type="button"
              className="primary button"
              onClick={() => history.push(`${pathname}/new`)}>
                Skapa ny
            </button>
          </div>
        </div>
        <div className="box">
          <div className="row align-middle">
            <div className="column">
              <SelectFormInput
                input={{
                  value: !!filter.archived,
                  onBlur: _.noop,
                  onChange: archived => filterWorkerTypes(filter.query, archived ? archived.value : false),
                }}
                label="Arkiverade"
                meta={{}}
                valueKey="value"
                labelKey="label"
                clearable={false}
                options={booleanValues} />
            </div>
          </div>
          {workerTypes &&
            <div className="box">
              <AdminList
                query={filter.query}
                columns={columns}
                rows={workerTypes}
                onSort={sortItems}
                onRowSelected={row => history.push(`${pathname}/${row.id}`)} />
            </div>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  workerTypeList: {
    filter,
    isFetching,
    filteredList: workerTypes,
  },
}) => ({
  isFetching,
  filter,
  workerTypes,
});

const mapDispatchToProps = dispatch => ({
  fetchWorkerTypes: () =>
    dispatch(fetchWorkerTypes()),
  filterWorkerTypes: (query, archived) =>
    dispatch(filterWorkerTypes(query, archived)),
  sortItems: sorter =>
    dispatch(sortItems(sorter)),
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(WorkerTypesContainer));



// WEBPACK FOOTER //
// ./src/containers/WorkerTypesContainer/WorkerTypesContainer.js